import { useEffect, useState } from "react";
import { Alert, Snackbar } from "@mui/material";
import { useSelector } from "react-redux";

export default function Notification() {
  const notification = useSelector((state) => state.notificationReducer);

  const [openNotification, setOpenNotification] = useState(notification.open);

  useEffect(() => {
    setOpenNotification(notification.open);
  }, [notification]);
  const handleClose = () => setOpenNotification(false);
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      open={openNotification}
      // autoHideDuration={6000}
      autoHideDuration={notification.duration || 6000}
      onClose={() => handleClose()}
    >
      <Alert
        onClose={handleClose}
        severity={notification.variant==="success"?"success":"error"}
        sx={{ width: "100%" }}
      >
        {notification.message}
      </Alert>
    </Snackbar>
  );
}
